/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBrokenShield: {
  name: 'broken_shield';
  data: string;
} = {
  name: 'broken_shield',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="m240.242 270.039 48.479-17.192L158.139 45.765h119.637L392.722 275.51l-57.864 19.535 96.301 207.877C522.436 402.026 539.688 219.73 539.688 39.409H66.056c0 243.936 50.266 485.384 236.681 536.613 45.474-9.695 82.424-29.438 112.404-56.952L240.242 270.039z"/></svg>`,
};
